import keys from 'constants/keys'
import { TASK_STATUS_CONFIG } from 'utils/taskAnalytics'

export const statusMeta: Record<
  string,
  { title: string; bg: string; headerBg: string; border: string; text: string; bar: string; selectedBg: string }
> = {
  risk: {
    title: 'Needs attention',
    bg: '#FFF1F2',
    headerBg: '#FFE4E6',
    border: '#FECDD3',
    text: '#9F1239',
    bar: '#F43F5E',
    selectedBg: '#FFECEF',
  },
  progress: {
    title: 'In progress',
    bg: '#FFFBEB',
    headerBg: '#FEF3C7',
    border: '#FDE68A',
    text: '#92400E',
    bar: '#F59E0B',
    selectedBg: '#FFF7DA',
  },
  done: {
    title: 'Completed',
    bg: '#ECFDF5',
    headerBg: '#D1FAE5',
    border: '#A7F3D0',
    text: '#047857',
    bar: '#10B981',
    selectedBg: '#E3FCEE',
  },
}

export const contextStatusMeta: Record<
  number,
  { label: string; bg: string; border: string; text: string; bar: string }
> = {
  [keys.TASK_STATUSES.TODO.value]: {
    label: keys.TASK_STATUSES.TODO.localeLiteral,
    bg: TASK_STATUS_CONFIG.todo.bg,
    border: TASK_STATUS_CONFIG.todo.border,
    text: TASK_STATUS_CONFIG.todo.text,
    bar: TASK_STATUS_CONFIG.todo.bar,
  },
  [keys.TASK_STATUSES.INPROGRESS.value]: {
    label: keys.TASK_STATUSES.INPROGRESS.localeLiteral,
    bg: TASK_STATUS_CONFIG.inProgress.bg,
    border: TASK_STATUS_CONFIG.inProgress.border,
    text: TASK_STATUS_CONFIG.inProgress.text,
    bar: TASK_STATUS_CONFIG.inProgress.bar,
  },
  [keys.TASK_STATUSES.DONE.value]: {
    label: keys.TASK_STATUSES.DONE.localeLiteral,
    bg: TASK_STATUS_CONFIG.done.bg,
    border: TASK_STATUS_CONFIG.done.border,
    text: TASK_STATUS_CONFIG.done.text,
    bar: TASK_STATUS_CONFIG.done.bar,
  },
  [keys.TASK_STATUSES.SKIPPED.value]: {
    label: keys.TASK_STATUSES.SKIPPED.localeLiteral,
    bg: TASK_STATUS_CONFIG.done.bg,
    border: TASK_STATUS_CONFIG.done.border,
    text: TASK_STATUS_CONFIG.done.text,
    bar: TASK_STATUS_CONFIG.done.bar,
  },
  [keys.TASK_STATUSES.APPROVED.value]: {
    label: keys.TASK_STATUSES.APPROVED.localeLiteral,
    bg: TASK_STATUS_CONFIG.approved.bg,
    border: TASK_STATUS_CONFIG.approved.border,
    text: TASK_STATUS_CONFIG.approved.text,
    bar: TASK_STATUS_CONFIG.approved.bar,
  },
  [keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.value]: {
    label: keys.TASK_STATUSES.APPROVED_WITH_RESERVATION.localeLiteral,
    bg: TASK_STATUS_CONFIG.approvedWithReservation.bg,
    border: TASK_STATUS_CONFIG.approvedWithReservation.border,
    text: TASK_STATUS_CONFIG.approvedWithReservation.text,
    bar: TASK_STATUS_CONFIG.approvedWithReservation.bar,
  },
  [keys.TASK_STATUSES.DISAPPROVED.value]: {
    label: keys.TASK_STATUSES.DISAPPROVED.localeLiteral,
    bg: TASK_STATUS_CONFIG.rejected.bg,
    border: TASK_STATUS_CONFIG.rejected.border,
    text: TASK_STATUS_CONFIG.rejected.text,
    bar: TASK_STATUS_CONFIG.rejected.bar,
  },
  [keys.TASK_STATUSES.REVIEWED_BY_AI.value]: {
    label: keys.TASK_STATUSES.REVIEWED_BY_AI.localeLiteral,
    bg: TASK_STATUS_CONFIG.reviewedByAi.bg,
    border: TASK_STATUS_CONFIG.reviewedByAi.border,
    text: TASK_STATUS_CONFIG.reviewedByAi.text,
    bar: TASK_STATUS_CONFIG.reviewedByAi.bar,
  },
}
